import SetReportingIntervalModal from './set-reporting-interval-modal.vue'
export default SetReportingIntervalModal
